import { Flex, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { formatDuration, formatEventTime } from 'src/meetings/utils/date-utils';
import { MeetingPlatformIcon } from './MeetingPlatformIcon';
import type { MeetingPlatform } from 'src/meetings/models';

type Props = {
  scheduledStartAt: string;
  scheduledEndAt: string;
  platform: MeetingPlatform | null;
};

export const EventTime = ({ scheduledStartAt, scheduledEndAt, platform }: Props) => {
  const timeText = formatEventTime(scheduledStartAt, scheduledEndAt);
  const duration = formatDuration(scheduledStartAt, scheduledEndAt);

  return (
    <Flex align="center" gap="xxs">
      {platform && <MeetingPlatformIcon platform={platform} size={16} />}
      <Text size="sm" fw={FONT_WEIGHTS.semibold} c="gray.6">
        {timeText} {duration}
      </Text>
    </Flex>
  );
};
